import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
//import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})


export class HomeComponent  {
  query={};
  submitted:boolean=false;

  //private applicationCollection: AngularFirestoreCollection<any>;

  
  nameC = new FormControl('', [
    Validators.required,
    Validators.minLength(4),
  ]);
  emailC= new FormControl('', [
    Validators.required,
    Validators.email
  ]);
  phoneC= new FormControl('', [
    Validators.required,
    Validators.minLength(10),
    Validators.maxLength(10),
    Validators.pattern('[0-9]+')
  ]);
  messageC= new FormControl('', [
    Validators.required,
    Validators.maxLength(256),
  ]);


constructor() {
  //this.applicationCollection = afs.collection<any>('queries');

}


addQuery() {
  // this.applicationCollection.add(this.query).then(res => {
  //  this.query={};
  //  this.submitted=true;
  // });
}




}